import React from 'react';
interface CTAButtonProps {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
  fullWidth?: boolean;
  href?: string;
}
export function CTAButton({
  children,
  className = '',
  onClick,
  fullWidth = false,
  href
}: CTAButtonProps) {
  const classes = `
    bg-[#D4A843] text-[#0A0A0A] hover:bg-[#FF8C00] 
    font-bold text-lg md:text-xl py-4 px-8 rounded-lg 
    transition-all duration-300 transform hover:scale-105 
    shadow-[0_0_20px_rgba(212,168,67,0.3)] hover:shadow-[0_0_30px_rgba(255,140,0,0.5)]
    flex items-center justify-center text-center
    ${fullWidth ? 'w-full' : 'w-full md:w-auto'}
    ${className}
  `;
  if (href) {
    return <a href={href} target="_blank" rel="noopener noreferrer" className={classes} data-id="element-288">
        {children}
      </a>;
  }
  return <button onClick={onClick} className={classes} data-id="element-289">
      {children}
    </button>;
}